import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { EmployeeRolesEnum } from '@analytics-soa/shared-models';
export class CreateUserDto {
  @ApiProperty()
  @IsNotEmpty() id: Number;
  @ApiProperty()
  @IsNotEmpty() username: string;
  @ApiProperty()
  @IsNotEmpty() password: string;
  @ApiProperty()
  @IsNotEmpty() @IsEmail() email?: string;
  @ApiProperty()
  @IsNotEmpty() clientCode: string;
  @ApiProperty({ enum: Object.values(EmployeeRolesEnum) })
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
  @ApiProperty()
  @IsNotEmpty() divisionId: number[];
  @ApiProperty()
  @IsNotEmpty() isActive: boolean;
  @ApiProperty()
  createdAt: Date;
  @ApiProperty()
  @IsOptional()
  createdUser: string;
  @ApiProperty()
  versionFlag: number;
}
export class updateUserDto {
  @ApiProperty()
  @IsNotEmpty() id: Number;
  @ApiProperty()
  @IsNotEmpty() username: string;
  @ApiProperty()
  @IsNotEmpty() password: string;
  @ApiProperty()
  @IsNotEmpty() @IsEmail() email?: string;
  @ApiProperty()
  @IsNotEmpty() clientCode: string;
  @ApiProperty({ enum: Object.values(EmployeeRolesEnum) })
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
  @ApiProperty()
  @IsNotEmpty() divisionId: number;
  @ApiProperty()
  @IsNotEmpty() isActive: boolean;
  @ApiProperty()
  updatedAt: Date;
  @ApiProperty()
  @IsOptional()
  updatedUser: string;
  @ApiProperty()
  versionFlag: number;
}

export class UpdateUserDto {
  @ApiProperty()
  @IsNotEmpty() username: string;
  @ApiProperty() password: string;
  @ApiProperty()
  @IsNotEmpty() @IsEmail() email?: string;
  @ApiProperty()
  @IsNotEmpty() clientCode: string;
  @ApiProperty({ enum: Object.values(EmployeeRolesEnum) })
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
  @ApiProperty()
  @IsNotEmpty() divisionId: number;
  @ApiProperty()
  @IsNotEmpty() isActive: boolean;
  @ApiProperty()
  updatedAt: Date;
  @ApiProperty()
  @IsOptional()
  updatedUser: string;
  @ApiProperty()
  versionFlag: number;
}
export class UserDto {
  @ApiProperty()
  @IsNotEmpty() id: number;
  @ApiProperty()
  @IsNotEmpty() username: string;
  @ApiProperty()
  @IsNotEmpty() @IsEmail() email?: string;
  @ApiProperty()
  @IsNotEmpty() clientCode: string;
  @ApiProperty()
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
}
export class LoginUserDto {
  @ApiProperty()
  @IsNotEmpty() readonly username: string;
  @ApiProperty()
  @IsNotEmpty() readonly password: string;
}